import React ,{useState } from "react";
import { gql, useMutation,useQuery } from '@apollo/client';
import { Checkbox, Dialog, Pane,Spinner, toaster } from 'evergreen-ui'
import Cookies from 'js-cookie';
import { FieldBtn } from "../../dues/dues.style";
import { AppInputField, AppInputFieldBtn, AppInputFieldSelect, InputFieldTitleText } from "../../../../../widget/styledComponents/input_field.style";
import { PickPropertyType } from "./property_widget_compnent";
// import { capitalizeFirstLetterOfWords } from "../../../../../widget/util";

export const ADD_PROPERTY = gql`
mutation Property_create($ownerId: ID!, $isOwnerAndResidentSamePerson: Boolean!, $facilityId: ID!, $type: PropertyTypes!, $address: String!, $numberOfRooms: Int!, $tags: [TagInput!]!, $squareMeter: Float) {
  property_create(ownerId: $ownerId, isOwnerAndResidentSamePerson: $isOwnerAndResidentSamePerson, facilityId: $facilityId, type: $type, address: $address, numberOfRooms: $numberOfRooms, tags: $tags, squareMeter: $squareMeter) {
    code
    success
    error
    data {
      _id
      address
      createdAt
    }
  }
}
`;


export const FETCH_OWNERS_LIST = gql`
query Owners_getByFacility($facilityId: ID!, $pagination: PaginationInput!) {
  owners_getByFacility(facilityId: $facilityId, pagination: $pagination) {
    _id
    id
    email
    name
    phone
    photo
    facility
    isAccountActivated
    createdAt
  }
}
`;

export default function AddPropertyBtn(props) {
const accesTokenValue = Cookies.get('userAccessToken');
const [addProperty, { loading }] = useMutation(ADD_PROPERTY);
const [isShown, setIsShown] = React.useState(false)
const facilityId = props.facilityId;
const [checked, setChecked] = React.useState(false)
const [dataObject, setDataObject] = useState({
  facilityId: facilityId,
  isOwnerAndResidentSamePerson:checked,
  tags: [
    {
      "name": "name",
      "value": "dsfcsd"
    }
  ],
});

const handleInputChange = (event) => {
  const { name, value } = event.target;
  let va = value



    if(name ==='numberOfRooms'){
      va = parseInt(value)
    }else if(name==="squareMeter"){
      va = parseFloat(value)
      let floatValue = va.toFixed(1);
      console.log("save as flit",typeof floatValue)
      va = parseFloat(floatValue)
      console.log("save as flit",typeof va)
    }
    setDataObject({
      ...dataObject,
      [name]: va
    });
  
};

const handleOwnerSelect = (value) => {
    setDataObject({
      ...dataObject,
      ownerId:value
    });
};
const handlePropertySelect  = (value) => {
    console.log(value)
    setDataObject({
      ...dataObject,
      type:value
    });
};

    

const handleSubmit=(e)=>{
  e.preventDefault()


  console.log(dataObject)
  
  addProperty({
    variables:dataObject,
    context: {
      headers: {
        Authorization: `Bearer ${accesTokenValue}`,
      },
    },
  })
  .then((response) => {
    toaster.success("Property added successfully.")
    window.location.reload()
  })
  .catch((error) => {
    toaster.danger(error.message)
  });
}
        return (
          <Pane>
            <Dialog
              isShown={isShown}
              title="Add Unit"
              onCloseComplete={() => setIsShown(false)}
              hasHeader={true}
              shouldCloseOnOverlayClick={false}
              shouldCloseOnEscapePress={false}
              hasFooter ={false}
            >
                
               
                <div className=''>
                <div>
                <form onSubmit={handleSubmit}>
                {/* <form> */}
                    <div className='row'>
                            <div className='col s12 '>
                                <InputFieldTitleText>
                                    Address
                                </InputFieldTitleText>
                                <AppInputField
                                    type="text" 
                                    placholder="Femi ojo"
                                    name="address" // Change to the desired field name in the object
                                    onChange={handleInputChange}
                                required/> 
                            </div>
                            <div className='col s12 '>
                                <InputFieldTitleText>
                                    Owner
                                </InputFieldTitleText>
                                <PickOwner onSelect={handleOwnerSelect}/>
                                <Checkbox 
                                  checked={checked}
                                  onChange={e =>{
                                    setChecked(e.target.checked)
                                    setDataObject({
                                      ...dataObject,
                                      isOwnerAndResidentSamePerson:e.target.checked
                                    });
                                  }}
                                  label="Is this person also a resident of the property?"
                                  
                                  
                                />
                            </div>

                            <div className='col s12 '>
                                <InputFieldTitleText>
                                    Property Type
                                </InputFieldTitleText>
                                <PickPropertyType onSelect={handlePropertySelect}/>
                            </div>
                            <div className='col s12 '>
                                <InputFieldTitleText>
                                    Number of room
                                </InputFieldTitleText>
                                <AppInputField
                                    type="number" 
                                    placholder=""
                                    name="numberOfRooms" // Change to the desired field name in the object
                                    onChange={handleInputChange}
                                required/> 
                            </div>
                            <div className='col s12 '>
                                <InputFieldTitleText>
                                    Square meter
                                </InputFieldTitleText>
                                <AppInputField
                                    type="number" 
                                    placholder="Enter square meter"
                                    name="squareMeter" // Change to the desired field name in the object
                                    onChange={handleInputChange}
                                required/> 
                            </div>
                            {/* <div className='col s12 '>
                                <InputFieldTitleText>
                                    Add Property Tags
                                </InputFieldTitleText>
                                <AddTagForProperty onSelect={handleTagsSelect}/>
                            </div> */}
                            
                            <div className='row'>
                                <div className='col s12 right' style={{
                                    display:"flex",
                                    flexWrap:"wrap",
                                    justifyContent:"end"
                                }}>
                                    <div className='' style={{
                                        width:"120px",
                                        padding:"16px "
                                    }}>
                                        {loading  &&
                                        <center>
                                            <Spinner/>
                                        </center>
                                        }
                                        {!loading &&
                                            <AppInputFieldBtn className=''
                                            type="submit"
                                            disabled={loading}
                                            // onClick={()=>handleSubmit()}
                                          >
                                                Add
                                          </AppInputFieldBtn>
                                        }
                                        
                                    </div>
                                </div>
                            </div>
                            <br/>
                    </div>
                    </form>
                </div>
                </div>
            </Dialog>
            <div className=''>
                <FieldBtn
                    onClick={() => setIsShown(true)}
                    class="mt-50 waves-effect waves-light btn-flat  ">
                    <i class="material-icons left">add</i>
                    Add Units 
                </FieldBtn>
            </div>
    
          </Pane>
        )
}

const PickOwner = ({ onSelect }) => {
const facilityId = Cookies.get('facilityId');

const { loading,error,data }  = useQuery(FETCH_OWNERS_LIST,{
variables: {
    facilityId:facilityId,
    pagination: {
        "cursor": null,
        "limit": 1000
    },
    },
});

const [selectedOption, setSelectedOption] = useState('');

if (loading) return <Spinner/>;
if (error) return <p>Error: {error.message}</p>;
const options = data.owners_getByFacility;
const handleSelect = (event) => {
  const selectedValue = event.target.value;
  setSelectedOption(selectedValue);
  console.log("Selected value:", selectedValue);
  onSelect(selectedValue)
};
  return (
    <div>
        <AppInputFieldSelect
            className="browser-default" required
             value={selectedOption} onChange={handleSelect}
            >
            <option value="" disabled selected>Choose your option</option>
            {options.map((option) => (
            <option key={option.id}  value={option.id}
            >
                {option.name}
            </option >
            ))}
        </AppInputFieldSelect>
    </div>
  )
}





// const AddTagForProperty = ({ onSelect }) => {

// const [keyValueArray, setKeyValueArray] = useState([]);
// const [inputKey, setInputKey] = useState('');
// const [inputValue, setInputValue] = useState('');

// const handleAddKeyValuePair = (e) => {
//     e.preventDefault()
//     if (inputKey.trim() !== '' && inputValue.trim() !== '') {
//     setKeyValueArray((prevArray) => [
//         ...prevArray,
//         { name: inputKey, value: inputValue },
//     ]);
//     setInputKey('');
//     setInputValue('');
//     }
//     onSelect(keyValueArray)
//     // console.log(keyValueArray)
// };


//     return (
//       <div className="row">
//         <div className="col s6">
//           <label>
//             Key:
//             <AppInputField
//               type="text"
//               value={inputKey}
//               onChange={(e) => setInputKey(e.target.value)}
//             />
//           </label>
//         </div>
//         <div className="col s6">
//           <label>
//             Value:
//             <AppInputField
//               type="text"
//               value={inputValue}
//               onChange={(e) => setInputValue(e.target.value)}
//             />
//           </label>
//         </div>
//         <div className="col s12">
//             <Button onClick={handleAddKeyValuePair}>
//                 <i className="material-icons">add</i>
//             </Button>
//         </div>
        
//         <div className="col s12">
//             <ul className="collection with-header">
//                 {keyValueArray.map((item, index) => (
//                     <li className="collection-item">
//                         <div>
//                             <b>{capitalizeFirstLetterOfWords(item.name)}</b>: {item.value}
//                             <IconButton marginBottom={8} className="secondary-content" icon={SmallCrossIcon} 
                            
//                             />
//                         </div>
//                     </li>
//                 ))}
//             </ul>
//         </div>
  
       
//       </div>
//     );
// }